<template>
  <div class="layout layout--checkout">
    <a
      class="visually-hidden"
      href="#main"
    >
      {{ $t('Skip to content') }}
    </a>

    <AppNotification />

    <CheckoutHeader class="layout__checkout-header" />

    <main class="layout__main">
      <slot />
    </main>

    <CheckoutFooter class="layout__checkout-footer" />
    <CartRestore />
  </div>
</template>

<style>
@import url("~layers/app/layouts/default.css");
@import url("~layers/app/layouts/checkout.css");
</style>
